import { Head, Link } from "@inertiajs/react"
import { ArrowLeft, Skull } from "lucide-react"

import { Divider } from "@/components/divider"
import { Card } from "@/components/ui/card"
import AppLayout from "@/layouts/app-layout"
import { dashboardPath } from "@/routes"
import type { BreadcrumbItem, JoinLeagueErrorProps } from "@/types"

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function JoinLeagueError(_props: JoinLeagueErrorProps) {
  const breadcrumbs: BreadcrumbItem[] = [{ title: "League Invitation" }]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Invalid Invite" />

      <div
        className="mx-auto flex w-full max-w-7xl items-center justify-center px-4 py-8"
        style={{ minHeight: "calc(100vh - 16rem)" }}
      >
        <Card className="flex w-full max-w-lg flex-col items-center px-8 py-12 text-center">
          {/* Skull shield */}
          <div
            className="mb-6 flex h-24 w-20 items-start justify-center pt-4 [clip-path:polygon(8%_0%,92%_0%,100%_8%,100%_85%,50%_100%,0%_85%,0%_8%)]"
            style={{
              background:
                "linear-gradient(180deg, oklch(0.30 0.08 28), oklch(0.18 0.04 28))",
              border: "2px solid oklch(0.40 0.15 28)",
            }}
          >
            <Skull className="text-destructive mt-1 size-10" />
          </div>

          {/* Headline */}
          <p className="text-destructive mb-2 text-xs font-bold tracking-widest uppercase">
            Summons Denied
          </p>
          <h1
            className="font-display text-destructive text-4xl leading-none font-bold"
            style={{
              textShadow:
                "0 0 8px oklch(0.55 0.24 28 / 0.3), 0 1px 0 oklch(0.40 0.15 28), 0 2px 4px oklch(0 0 0 / 0.5)",
            }}
          >
            This Summons Has Expired
          </h1>

          {/* Divider */}
          <Divider className="mt-5 mb-5 w-full">
            <span style={{ color: "oklch(0.40 0.10 28)" }}>◆</span>
          </Divider>

          {/* Description */}
          <p className="text-muted-foreground max-w-xs text-sm">
            The invite link is no longer valid. It may have expired or already
            been used. Ask the league commissioner for a fresh summons.
          </p>

          {/* CTA */}
          <Link
            href={dashboardPath()}
            className="hover:bg-muted mt-8 inline-flex h-10 cursor-pointer items-center justify-center gap-2 border-2 px-5 text-sm font-bold tracking-wider uppercase transition-colors"
            style={{ borderColor: "var(--border-heavy)" }}
          >
            <ArrowLeft className="size-4" />
            Return to Dashboard
          </Link>
        </Card>
      </div>
    </AppLayout>
  )
}
